var _path, _path2, _circle, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWefenexus(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 213,
    height: 213,
    viewBox: "0 0 213 213",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M208.478 180.744C187.253 180.744 187.253 206.262 166.028 206.262C144.803 206.262 144.803 180.744 123.578 180.744C102.353 180.744 102.353 206.262 81.128 206.262",
    stroke: "#0050C0",
    strokeWidth: 6.63462,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M208.478 146.038C187.253 146.038 187.253 171.556 166.028 171.556C144.803 171.556 144.803 146.038 123.578 146.038C102.353 146.038 102.353 171.556 81.128 171.556",
    stroke: "#0050C0",
    strokeWidth: 6.63462,
    strokeMiterlimit: 10
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 37.1539,
    cy: 37.1539,
    r: 33.8366,
    transform: "matrix(-1 0 0 1 196.46 35.9041)",
    stroke: "#0050C0",
    strokeWidth: 6.63462
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M159.308 30.5961V19.9807",
    stroke: "#0050C0",
    strokeWidth: 6.63462
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M159.308 126.135V115.519",
    stroke: "#0050C0",
    strokeWidth: 6.63462
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M116.846 73.0577L106.231 73.0577",
    stroke: "#0050C0",
    strokeWidth: 6.63462
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M212.385 73.0577L201.769 73.0577",
    stroke: "#0050C0",
    strokeWidth: 6.63462
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M129.283 43.0328L121.776 35.5266",
    stroke: "#0050C0",
    strokeWidth: 6.63462
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M196.838 110.588L189.332 103.082",
    stroke: "#0050C0",
    strokeWidth: 6.63462
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M129.283 103.083L121.776 110.59",
    stroke: "#0050C0",
    strokeWidth: 6.63462
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M196.838 35.5281L189.332 43.0343",
    stroke: "#0050C0",
    strokeWidth: 6.63462
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M142.215 111.927L137.941 121.644",
    stroke: "#0050C0",
    strokeWidth: 6.63462
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M180.675 24.4715L176.401 34.1887",
    stroke: "#0050C0",
    strokeWidth: 6.63462
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M176.244 111.994L180.479 121.729",
    stroke: "#0050C0",
    strokeWidth: 6.63462
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M138.135 24.3863L142.369 34.1206",
    stroke: "#0050C0",
    strokeWidth: 6.63462
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M198.795 88.6654L208.667 92.5671",
    stroke: "#0050C0",
    strokeWidth: 6.63462
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M119.227 88.6654L109.354 92.5671",
    stroke: "#0050C0",
    strokeWidth: 6.63462
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M109.946 53.5486L119.818 57.4503",
    stroke: "#0050C0",
    strokeWidth: 6.63462
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M198.52 56.7694L208.323 52.697",
    stroke: "#0050C0",
    strokeWidth: 6.63462
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M6.71155 19.9807C6.71155 19.9807 43.2019 19.9811 43.2019 39.8846C43.2019 27.4447 61.4471 19.9807 79.6923 19.9807",
    stroke: "#0050C0",
    strokeWidth: 6.63462
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M46.5192 59.7885C46.5192 59.7885 69.7404 59.7885 69.7404 79.6923C69.7404 75.2692 74.3846 59.7885 92.9615 59.7885",
    stroke: "#0050C0",
    strokeWidth: 6.63462
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M39.2819 159.308V159.308C39.2819 148.315 48.1931 139.404 59.1857 139.404H66.4235V152.673",
    stroke: "#0050C0",
    strokeWidth: 6.63462
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M33.853 159.308V159.308C33.853 148.315 24.9417 139.404 13.9491 139.404H6.71136V152.673",
    stroke: "#0050C0",
    strokeWidth: 6.63462
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M39.2819 139.404V139.404C39.2819 128.411 48.1931 119.5 59.1857 119.5H66.4235V132.769",
    stroke: "#0050C0",
    strokeWidth: 6.63462
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M33.853 139.404V139.404C33.853 128.411 24.9417 119.5 13.9491 119.5H6.71136V132.769",
    stroke: "#0050C0",
    strokeWidth: 6.63462
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M66.4231 159.308L59.1853 159.308C48.1927 159.308 39.2815 168.219 39.2815 179.212L39.2815 192.481L46.5192 192.481C57.5118 192.481 66.4231 183.57 66.4231 172.577L66.4231 159.308Z",
    stroke: "#0050C0",
    strokeWidth: 6.63462
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M36.5671 86.3269L29.979 94.3791C23.018 102.887 23.018 116.681 29.979 125.189L36.5671 133.241L43.1553 125.189C50.1162 116.681 50.1162 102.887 43.1553 94.3791L36.5671 86.3269Z",
    stroke: "#0050C0",
    strokeWidth: 6.63462
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M6.71155 159.308L13.9493 159.308C24.9419 159.308 33.8532 168.219 33.8532 179.212L33.8531 192.481L26.6154 192.481C15.6228 192.481 6.71155 183.57 6.71155 172.577L6.71155 159.308Z",
    stroke: "#0050C0",
    strokeWidth: 6.63462
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M36.5673 192.481V212.385",
    stroke: "#0050C0",
    strokeWidth: 6.63462
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWefenexus);
export default __webpack_public_path__ + "static/media/wefenexus.5a6476189dab2acc503467d30bb1b098.svg";
export { ForwardRef as ReactComponent };